<template>
  <button
    :disabled="loading"
    type="button"
    :class="`btn btn-primary d-flex text-center align-items-center ${
      errorData ? 'save-error' : ''
    }`"
    id="save-btn"
    @click="$emit('saving')"
  >
    <Loader :loaderSize="'small'" v-if="loading" class="mr-2" />
    <div v-else class="icons mr-1">
      <font-awesome-icon :icon="primaryIcon" class="primary-icon" />
      <span class="secondary-icon">
        <font-awesome-icon icon="exclamation-circle" />
      </span>
    </div>
    {{ text }}
  </button>
</template>

<script>
export default {
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    text: {
      Type: String,
      default: "Salva",
    },
    primaryIcon: {
      type: String,
      default: "check",
    },
  },
  data() {
    return { errorData: this.error };
  },
  watch: {
    error: function (newError, oldError) {
      this.errorData = newError;
      if (newError && !oldError) {
        this.errorAnimation();
      }
    },
  },
  methods: {
    errorAnimation: function () {
      setTimeout(() => {
        this.errorData = false;
        this.$emit("updateErrorValue", this.errorData);
      }, 800);
    },
  },
};
</script>

<style lang="scss" scoped>
#save-btn {
  transition: background-color 0.25s ease-in-out, border-color 0.25s ease-in-out,
    box-shadow 0.25s ease-in-out !important;
  &:focus {
    box-shadow: none;
  }
  .icons {
    position: relative;
    .primary-icon {
      transition: 0.25s all;
      transform: rotate(0deg);
      opacity: 1;
    }
    .secondary-icon {
      position: absolute;
      left: 0;
      transition: 0.25s all;
      transform: rotate(-180deg);
      opacity: 0;
    }
  }
}

#save-btn.save-error {
  background-color: #e74a3b !important;
  border-color: #e74a3b !important;
  animation: shake 0.2s ease-in-out 1;
  &.focus,
  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(231, 74, 60, 0.15) !important;
  }
  .icons {
    .primary-icon {
      transform: rotate(180deg);
      opacity: 0;
    }
    .secondary-icon {
      transform: rotate(0deg);
      opacity: 1;
    }
  }
}

.DARK_MODE #save-btn.save-error {
  background-color: rgba(231, 74, 60, 0.15) !important;
  border-color: #e74a3b !important;
  color: #e74a3b !important;
  animation: shake 0.2s ease-in-out 1;
  &:hover {
    background-color: rgba(231, 74, 60, 0.15) !important;
  }
  &.focus,
  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(231, 74, 60, 0.15) !important;
  }
  .icons {
    .primary-icon {
      transform: rotate(180deg);
      opacity: 0;
    }
    .secondary-icon {
      transform: rotate(0deg);
      opacity: 1;
    }
  }
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
</style>
